"use client";

import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Facebook, Twitter, Instagram, Linkedin, Youtube, Mail } from "lucide-react";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-wrap justify-center gap-4">
        <div className="h-4 w-16 bg-muted/30 animate-pulse rounded" />
        <div className="h-4 w-16 bg-muted/30 animate-pulse rounded" />
        <div className="h-4 w-16 bg-muted/30 animate-pulse rounded" />
      </div>;
  }
  return <nav className="flex flex-wrap justify-center gap-x-6 gap-y-2">
      {menuItems.slice(0, 6).map(item => <Link key={item.id} to={item.href || "#"} className="text-sm text-foreground hover:text-primary relative after:absolute after:bottom-0 after:left-0 after:h-[1px] after:w-0 after:bg-primary after:transition-all after:duration-[var(--duration-medium)] after:ease-[var(--ease-smooth)] hover:after:w-full">
          {item.label}
        </Link>)}
    </nav>;
}
export default function Footer() {
  const socialLinks = [{
    icon: Facebook,
    href: "https://facebook.com",
    label: "Facebook"
  }, {
    icon: Twitter,
    href: "https://twitter.com",
    label: "Twitter"
  }, {
    icon: Instagram,
    href: "https://instagram.com",
    label: "Instagram"
  }, {
    icon: Linkedin,
    href: "https://linkedin.com",
    label: "LinkedIn"
  }, {
    icon: Youtube,
    href: "https://youtube.com",
    label: "YouTube"
  }, {
    icon: Mail,
    href: "mailto:info@jeen.org.ug",
    label: "Email"
  }];
  return <footer className="w-full bg-background border-t border-muted">
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-center">
          {}
          <div className="text-center md:text-left">
            <p className="text-sm text-muted-foreground">© 2026 Jestu Education Empowerment Network (JEEN).<div>All rights reserved.</div></p>
          </div>

          {}
          <div className="flex justify-center">
            <MenuProvider menu_id="35">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="flex justify-center md:justify-end gap-4">
            {socialLinks.map((social, i) => <Link key={i} to={social.href} newTab aria-label={social.label} className="text-muted-foreground hover:text-primary transition-all duration-[var(--duration-fast)] hover:opacity-70">
                <social.icon className="size-5" />
              </Link>)}
          </div>
        </div>
      </div>
    </footer>;
}